import { ACCOUNT_MENU_TOGGLE } from '../actions/account-menu';

export default (state, action) => {
  if (!state) {
    return {
      open: false,
    };
  }

  switch (action.type) {
    case ACCOUNT_MENU_TOGGLE: {
      return {
        ...state,
        open: action.open,
      };
    }
    default:
  }

  return state;
};
